import {
  PARTNER_USER_ORDERS,
  type PartnerUserOrder,
} from '@/entities/user/api/user.api';
import { PAGE_SIZE_OPTIONS } from '@/shared/constants/pagination';
import {
  parseEnum,
  parsePageSize,
  parsePositiveInt,
  parseString,
} from '@/shared/lib/searchParams';

/** 05 사용자 URL 상태. page는 1부터 (API는 0부터) */
export interface UsersSearch {
  keyword?: string;
  order?: PartnerUserOrder;
  page?: number;
  /** 보기 개수. 없으면 DEFAULT_VIEW_PAGE_SIZE */
  size?: number;
}

export const validateUsersSearch = (
  search: Record<string, unknown>,
): UsersSearch => ({
  keyword: parseString(search.keyword),
  order: parseEnum(search.order, PARTNER_USER_ORDERS),
  page: parsePositiveInt(search.page),
  size: parsePageSize(search.size, PAGE_SIZE_OPTIONS),
});
